import { render, staticRenderFns } from "./notupload.vue?vue&type=template&id=27b3f3e3&scoped=true&"
import script from "./notupload.vue?vue&type=script&lang=js&"
export * from "./notupload.vue?vue&type=script&lang=js&"
import style0 from "./notupload.vue?vue&type=style&index=0&id=27b3f3e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3f3e3",
  null
  
)

export default component.exports